module.exports = {"attributes":{"width":"26","height":"26","viewBox":"0 0 26 26","xmlns":"http://www.w3.org/2000/svg"},"content":"<g fill-rule=\"nonzero\">     <path d=\"M13 5L6 9v8l7 4 7-4V9l-7-4zm1-1.74l7 4A2 2 0 0 1 22 9v8a2 2 0 0 1-1 1.74l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 4 17V9a2 2 0 0 1 1-1.74l7-4a2 2 0 0 1 2 0z\"/>     <path d=\"M13 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/settings.svg
// module id = 1443
// module chunks = 0